module.exports = __webpack_public_path__ + "static/img/palm.badd972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/palm.png
// module id = ShEj
// module chunks = 1